export default function initFeatureHighlights() {
  const navButtons = document.querySelectorAll('.feature-highlights__nav-button');
  const mediaItems = document.querySelectorAll('.feature-highlights__media-item');

  if (navButtons.length === 0 || mediaItems.length === 0) {
    console.warn("Feature Highlights: No nav buttons or media items found.");
    return;
  }

  function showMedia(index) {
    mediaItems.forEach((item) => {
      if (item.dataset.index === index) {
        item.classList.add("visible");
      } else {
        item.classList.remove("visible");
      }
    });
  }

  navButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const index = button.dataset.index;

      // Deactivate all nav buttons, activate the clicked one
      navButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Show the corresponding media item
      showMedia(index);
    });
  });

  // Activate the first button by default
  navButtons[0].classList.add("active");
  showMedia(navButtons[0].dataset.index);
}
